<template>
  <div class="home">
    <div class="top">
      <span>国内证书查询</span>
    </div>
    <div class="inputText">
      <input
        type="text"
        placeholder="请输入完整的公司名称"
        v-model="inputVal"
      />
    </div>

    <div class="tip">
      <span>说明：输入完整且正确的公司中文名称，才能显示出查询结果</span>
    </div>

    <div class="btn" @click="handleGoDeatil">
      <span>立即查询</span>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  //模板名称
  name: "signUp",
  //数据
  data() {
    return {
      inputVal: "",
      TimaId: -1,
      searchName: "",
    };
  },

  methods: {
    // handleInput() {
    //   clearTimeout(this.TimaId);
    //   this.TimaId = setTimeout(() => {
    //     this.searchName = this.inputVal;
    //   }, 500);
    // },

    handleGoDeatil() {
      if (this.inputVal == "") {
        Toast("公司名称不能为空");
        return false;
      }
      this.$router.push({
        path: "/companyDeatil",
        query: {
          name: this.inputVal,
        },
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='less'>
  /* 全局改变toast 提示框样式 */
  .van-toast__text {
    line-height: 60px !important;
    height: 60px !important;
    font-size: 28px !important;
  }

</style>
<style  lang="less" scoped>
.home {
  .top {
    height: 100px;
    background: #409eff;
    line-height: 100px;
    text-align: center;
    color: #fff;
    font-size: 44px;
  }

  .inputText {
    height: 150px;
    margin: 150px 30px 0 30px;
    padding: 30px;
    border: 1px solid #409eff;
    input {
      width: 620px;
      font-size: 36px;
      height: 150px;
      border: none;
    }
  }

  .tip {
    margin: 40px 30px 0 30px;
    font-size: 36px;
    line-height: 50px;
  }

  .btn {
    margin-top: 200px;
    display: flex;
    justify-content: center;
    span {
      display: block;
      width: 250px;
      height: 100px;
      background: #409eff;
      line-height: 100px;
      font-size: 36px;
      color: #fff;
      text-align: center;
      border-radius: 15px;
    }
  }

  // /deep/ .van-toast--html {
  //   line-height: 90px !important;
  //   height: 90px !important;
  //   font-size: 38px !important;
  // }
}
</style>




// WEBPACK FOOTER //
// src/pages/index/index.vue